import { noConflictsLabel } from 'owa-locstrings/lib/strings/noconflictslabel.locstring.json';
import { eventCanceled, conflictInfo } from './MailListItemMeetingInfo.locstring.json';
import loc, { format } from 'owa-localize';
import MailListItemDataProps from '../utils/types/MailListItemDataProps';
import MailListTableProps from '../utils/types/MailListTableProps';
import { observer } from 'mobx-react';
import getMeetingItem from 'owa-meeting-message/lib/utils/getMeetingItem';
import { getFutureConflictingMeetings } from 'owa-meeting-message/lib/utils/getMeetingRequestConflicts';
import isMeetingCancellation from 'owa-meeting-message/lib/utils/isMeetingCancellation';
import isMeetingRequest from 'owa-meeting-message/lib/utils/isMeetingRequest';
import shouldMeetingItemShowRSVP from 'owa-listview-rsvp/lib/utils/shouldMeetingItemShowRSVP';
import { observableToday } from 'owa-observable-datetime';
import { MeetingMessageButton } from 'owa-listview-rsvp';
import MeetingRequestMessageType from 'owa-service/lib/contract/MeetingRequestMessageType';
import * as React from 'react';

const styles = require('./MailListItem.scss');
export interface MailListItemMeetingInfoProps {
    mailListTableProps: MailListTableProps;
    mailListItemDataProps: MailListItemDataProps;
}

@observer
export default class MailListItemMeetingInfo extends React.Component<
    MailListItemMeetingInfoProps,
    any
> {
    private renderMeetingInfo(): JSX.Element {
        const meetingItem = getMeetingItem(this.props.mailListItemDataProps.latestItemId);
        const isSingleLineView = this.props.mailListTableProps.isSingleLine;

        // The item is not on store yet or does not have all the properties we need
        if (!meetingItem) {
            return null;
        }

        // Checks if this meeting item will be shown
        if (!shouldMeetingItemShowRSVP(meetingItem)) {
            return null;
        }

        let meetingInfoString = null;
        let numberString = null;
        if (isMeetingRequest(meetingItem.ItemClass)) {
            const futureConflictingMeetings = getFutureConflictingMeetings(
                meetingItem as MeetingRequestMessageType,
                observableToday()
            );

            if (futureConflictingMeetings.length > 0) {
                numberString =
                    futureConflictingMeetings.length > 1
                        ? futureConflictingMeetings.length - 1
                        : null;

                meetingInfoString = format(loc(conflictInfo), futureConflictingMeetings[0].Subject);
            } else {
                meetingInfoString = loc(noConflictsLabel);
            }
        }

        if (isMeetingCancellation(meetingItem.ItemClass)) {
            meetingInfoString = loc(eventCanceled);
        }

        return (
            <div
                className={
                    isSingleLineView ? styles.meetingInfoSingleLine : styles.meetingInfo3Column
                }>
                {meetingInfoString && (
                    <div className={styles.meetingInfoTextContainer}>
                        <span className={styles.meetingInfoText}>{meetingInfoString}</span>
                        {numberString && <span>{'+' + numberString}</span>}
                    </div>
                )}
                <div
                    className={
                        isSingleLineView
                            ? styles.meetingMessageButtonSLV
                            : styles.meetingMessageButton
                    }>
                    <MeetingMessageButton
                        item={meetingItem}
                        listViewType={this.props.mailListTableProps.listViewType}
                    />
                </div>
            </div>
        );
    }

    render() {
        return this.renderMeetingInfo();
    }
}
